export default __webpack_public_path__ + "static/media/img-01.08f9fcfa.jpg";